import basePathsUntyped from './baseHexagonColorPaths.json';

const basePaths = basePathsUntyped as { fill: string; d: string }[];
import { hslToHex } from './hsl';

export type HexPath = { fill: string; d: string };

const HEXAGON_ROW = [7, 8, 9, 10, 11, 12, 13, 12, 11, 10, 9, 8, 7];
const HEXAGON_SIZE = HEXAGON_ROW.reduce((a, n) => a + n, 0);

/** Port of `_get_color_paths_from_hue` from upstream (fixed dead `return path` → `color_path`). */
export function getColorPathsFromHue(hue: number): HexPath[] {
  if (hue === 0) {
    return basePaths.map((p) => ({ fill: p.fill, d: p.d }));
  }

  return basePaths.map((colorPath, index) => {
    if (index + 1 > HEXAGON_SIZE) {
      return { ...colorPath };
    }

    let indexIsInRowN = 0;
    let firstOfRowNIndex = 0;

    for (let i = 0; i < HEXAGON_ROW.length; i++) {
      firstOfRowNIndex += HEXAGON_ROW[i];

      if (firstOfRowNIndex > index) {
        indexIsInRowN = i;
        firstOfRowNIndex -= HEXAGON_ROW[i];
        break;
      }
    }

    const lastOfRowNIndex = firstOfRowNIndex + HEXAGON_ROW[indexIsInRowN] - 1;
    const saturationIndex = indexIsInRowN <= 0 ? index : (index % firstOfRowNIndex) + 1;
    const luminosityIndex = indexIsInRowN + 1;

    const saturation = index === lastOfRowNIndex ? 100 : (100 / HEXAGON_ROW[indexIsInRowN]) * saturationIndex;
    const luminosity = (100 / (1 + HEXAGON_ROW.length)) * luminosityIndex;

    return {
      ...colorPath,
      fill: hslToHex(hue / 3.6, saturation, luminosity),
    };
  });
}
